// extracted by mini-css-extract-plugin
export default {"menuItem":"ButtonBackgroundColor_menuItem__osLAQ"};